import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { setOperationStatusSchema } from '../../../../shared/validators/schemas/set-operation-status.schema';
import { AssetReservationRecordDto } from '../../dtos/asset-reservation-record.dto';
import { AssetReservationActionEnum } from '../../enums/asset-reservation-action.enum';
import { AssetReservationStatusEnum } from '../../enums/asset-reservation-status.enum';

/**
 * Validates if an action can be performed by validating the record data.
 * @param record - The record for the data validation.
 * @param action - The action to be validated.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canPerformAction = (
	record: AssetReservationRecordDto,
	action: AssetReservationActionEnum,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	switch (action) {
		case AssetReservationActionEnum.CANCEL:
			validationResult = setOperationStatusSchema(
				AssetReservationStatusEnum.CANCELLED,
			).validate(record, {
				abortEarly,
			});
			break;

		default:
			throw new Error(`Unknown action: ${action}`);
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
